export default __webpack_public_path__ + "static/media/OFF.abd48895.png";